import useApi from './request'

export interface ChatTurnShareResourceResponse {
  resourceType: 'FILE' | 'IMAGE'
  displayName: string
  contentType: string
  sizeBytes: number | null
  url: string | null
  sortOrder: number
}

export interface ChatTurnShareMessageResponse {
  role: 'user' | 'assistant'
  content: string
  status: string
  mode: 'chat' | 'image'
  sortOrder: number
  createdAt: string
  completedAt: string | null
  resources: ChatTurnShareResourceResponse[]
}

export interface PublicChatTurnShareResponse {
  shareId: string
  createdAt: string
  messages: ChatTurnShareMessageResponse[]
}

export async function getPublicTurnShareApi(shareId: string) {
  const { response, request } = useApi<{
    type: string
    code: string
    msg: string
    result?: PublicChatTurnShareResponse
  }>(`/ai-chat/public/shares/${encodeURIComponent(shareId)}`, {
    method: 'GET',
  })

  await request()
  return response
}
